import { render, staticRenderFns } from "./CotTraccaimentoChiamateListPage.vue?vue&type=template&id=33ef1622"
import script from "./CotTraccaimentoChiamateListPage.vue?vue&type=script&lang=js"
export * from "./CotTraccaimentoChiamateListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports